
namespace RioERP.Orders {
    export class OrderWebhookColumns {
        static columnsKey = 'Orders.OrderWebhook';
    }
}